export { default as BannerPlaceList } from './BannerPlaceList';



// WEBPACK FOOTER //
// ./src/modules/BannerPlace/pages/index.ts